import { getMonthInStringNotOneIndexBasedNew } from "../../../utils/common";

export const SalaryHeaders = [
  {
    key: "month_days",
    label: "Month",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => getMonthInStringNotOneIndexBasedNew(row?.month)
  },
  {
    key: "No of Employees",
    label: "No of Employees",
    align: "center",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.totalEmloyeeCountWhoPayPtax
  },
  {
    key: "Amount Of Tax",
    label: "Amount Of Tax (₹)",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => row?.totalPtaxAmountForThisMonth
  },
];

export const SalaryRows = [
  {
    slNo: 1,
    employeeName: "Barun Sharma",
    employee_code: "Pia002",
    designation: "IT",
    amountDrawnAs: "Salaried",
    monthDays: "31",
    payableDays: "31",
    presentDays: "23",
    earning: "₹35,000",
    deduction: "₹1,950",
    netpayable: "33,050",
  },


];